export class AlainSVConfig {
  /** å¤§å°ï¼é»è®¤ï¼`large` */
  size?: 'small' | 'large';
  /** é´è·ï¼é»è®¤ï¼`32` */
  gutter?: number;
  /** å¸å±ï¼é»è®¤ï¼`horizontal` */
  layout?: 'horizontal' | 'vertical';
  /** åæ°ï¼é»è®¤ï¼`3` */
  col?: number;
  /** æ¯å¦æ¾ç¤ºé»è®¤å¼ï¼å½åå®¹ä¸ºç©ºå¼æ¶æ¾ç¤º `-`ï¼é»è®¤ï¼`true` */
  default?: boolean;
  /** `label` åºå®å®½åº¦ï¼è¥ `null` æ `undefined` è¡¨ç¤ºéåºå®ï¼é»è®¤ï¼`null` */
  labelWidth?: number;
}
